import * as R from "ramda";
import { Position } from "client/typings";
export const presentation = R.pathOr(false, ["user", "theme", "isPresentation"]);
export const getUser = R.path(["user"]);
export const getProfile = R.path(["user", "profile"]);
export const authenticated = R.pathOr(false, ["user", "isAuthenticated"]);
export const getPosition = R.path(["user", "profile", "position"]);
export const student = R.pathEq(["user", "profile", "position"], Position.Student);
export const getUsername = R.path(["user", "profile", "username"]);
